import * as React from "react";
import { useCallback, useContext } from "react";
import DrilldownContext from "views/components/contexts/DrilldownContext";
import useWidgetResults from "views/components/useWidgetResults";
import useView from "views/hooks/useView";
import useCurrentQuery from "views/logic/queries/useCurrentQuery";
import useAssistantSidebar from "ai/sidebar/useAssistantSidebar";
import createMessagesWidgetSummaryRequest, {
  MESSAGES_WIDGET_TYPE
} from "ai/widget-summary/createMessagesWidgetSummaryRequest";
import WidgetSummaryButton from "ai/widget-summary/WidgetSummaryButton";
const MessagesWidgetSummaryActionComponent = ({ widget }) => {
  const { openWidgetSummary } = useAssistantSidebar();
  const { widgetData } = useWidgetResults(widget.id);
  const scope = useContext(DrilldownContext);
  const view = useView();
  const currentQuery = useCurrentQuery();
  const effectiveTimerange = widgetData == null ? void 0 : widgetData.effectiveTimerange;
  const onClick = useCallback(
    () => openWidgetSummary(
      createMessagesWidgetSummaryRequest(
        view,
        widget,
        { ...scope, timerange: effectiveTimerange != null ? effectiveTimerange : scope.timerange },
        currentQuery == null ? void 0 : currentQuery.filters
      )
    ),
    [openWidgetSummary, scope, effectiveTimerange, view, widget, currentQuery == null ? void 0 : currentQuery.filters]
  );
  return /* @__PURE__ */ React.createElement(
    WidgetSummaryButton,
    {
      widgetType: MESSAGES_WIDGET_TYPE,
      widgetEmpty: false,
      noData: (widgetData == null ? void 0 : widgetData.total) === 0,
      onClick
    }
  );
};
export default MessagesWidgetSummaryActionComponent;
